<script>
import ListSimulatorStudentComponent from '../../features/lists/ListSimulatorStudentComponent';
import ModalImportView from '../../../shared/views/ModalImportView';
import ModalStudentInfoView from '../../../account/views/ModalStudentInfoView';
import LiveSearchComponent from '../../../shared/features/LiveSearchComponent';

export default {
  name: 'ListSimulatorStudentView',
  components: {
    'modal-import': ModalImportView,
    'modal-student-info-view': ModalStudentInfoView,
  },
  extends: ListSimulatorStudentComponent,
  mixins: [LiveSearchComponent],
  data() {
    return {
      // Campo por el que filtra el API el buscador de simuladores
      searchField: 'Name',
    };
  },
};
</script>

<template>
  <div class="list-body">
    <!-- Toolbar de búsqueda y filtros estilo Appmisionate -->
    <div class="stream_toolbar">
      <div class="stream_search_box">
        <el-input
          v-model="searchName"
          type="text"
          placeholder="Buscar simulador por nombre..."
          prefix-icon="Search"
          clearable
          class="stream_search_input"
          @input="onSearchInput"
          @clear="onClearSearch"
          @keyup.enter="onSearchSubmit"
        />
      </div>
      <div class="stream_toolbar_meta">
        <span
          v-if="pagination.totalItems > 0 || (collection && collection.length > 0)"
          class="stream_count_badge"
        >
          <i class="uil uil-file-alt" />
          Mostrando <strong>{{ pagination.totalItems || collection.length }}</strong> simulador(es)
        </span>
      </div>
    </div>

    <!-- Grilla de Simuladores (mismos breakpoints que las clases en vivo) -->
    <div
      v-loading="isListLoading"
      element-loading-text="Cargando simuladores..."
      class="row sim_grid"
    >
      <div
        v-for="simulator in collection"
        :key="simulator.id"
        class="col-xl-3 col-lg-4 col-md-6 col-12 d-flex"
      >
        <div
          class="sim_card mb-30"
          @click="isValidateSubscrition('/estudiante/simuladores/' + simulator.id + '/aplicar')"
        >
          <!-- Portada del simulador -->
          <div class="sim_thumb">
            <img
              :src="getCoverImage(simulator.coverImageUrl)"
              :alt="simulator.name"
            >
            <div class="sim_play_overlay">
              <i class="uil uil-play" />
            </div>

            <div
              v-if="simulator.questionQuantity"
              class="sim_badge_questions"
            >
              <i class="uil uil-question-circle" /> {{ simulator.questionQuantity }} preguntas
            </div>

            <div class="sim_badge_duration">
              <i class="uil uil-clock-three" />
              <span v-if="simulator.duration">{{ simulator.duration }} min</span>
              <span v-else-if="simulator.isTimer">Con límite</span>
              <span v-else>Práctica libre</span>
            </div>
          </div>

          <!-- Cuerpo del simulador -->
          <div class="sim_body">
            <div class="sim_meta">
              <span
                v-if="simulator.university && simulator.university.name"
                class="sim_tag"
              >
                {{ simulator.university.name }}
              </span>
              <span
                v-else-if="simulator.difficultyLevel && simulator.difficultyLevel.name"
                class="sim_tag"
              >
                {{ simulator.difficultyLevel.name }}
              </span>
              <span
                v-else
                class="sim_tag"
              >
                Simulador Oficial
              </span>

              <span class="sim_status">
                <i class="uil uil-check-circle text-success" /> Disponible
              </span>
            </div>

            <h5
              class="sim_title"
              :title="simulator.name"
            >
              {{ simulator.name }}
            </h5>

            <p
              v-if="simulator.description"
              class="sim_desc"
            >
              {{ simulator.description }}
            </p>
            <p
              v-else
              class="sim_desc text-muted"
            >
              Evaluación oficial con cronómetro y análisis de puntaje final.
            </p>

            <div class="sim_footer">
              <span
                v-if="simulator.topScore"
                class="sim_score_info"
              >
                Puntaje máx: <strong>{{ simulator.topScore }} pts</strong>
              </span>
              <span
                v-else
                class="sim_score_info"
              >
                Examen diagnóstico
              </span>

              <span class="sim_cta_btn">
                Iniciar examen <i class="uil uil-arrow-right" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Estado vacío -->
    <div
      v-if="isCollectionEmpty(collection) && !isListLoading"
      class="stream_empty_state"
    >
      <div class="stream_empty_icon">
        <i class="uil uil-file-slash" />
      </div>
      <h3 class="stream_empty_title">
        No se encontraron simuladores
      </h3>
      <p class="stream_empty_text">
        {{ searchName ? `No encontramos simuladores que coincidan con "${searchName}".` : 'No hay simuladores disponibles en este momento.' }}
      </p>
      <el-button
        v-if="searchName"
        type="primary"
        size="small"
        class="mt-3"
        @click="onClearSearch"
      >
        Limpiar búsqueda
      </el-button>
    </div>

    <!-- Paginación -->
    <div
      v-if="!isCollectionEmpty(collection) && pagination.totalPages > 1"
      class="courses_pagination_wrapper"
    >
      <el-pagination
        v-model:current-page="currentPage"
        background
        layout="prev, pager, next"
        :page-count="pagination.totalPages"
        @current-change="onPageChange"
      />
    </div>

    <!-- Modales -->
    <modal-student-info-view
      v-if="modalSubscriptionInfo.isVisible"
      :form-data="studentInfoItem"
      :conf="modalSubscriptionInfo"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>
